var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5625C5.94922 1.5625 4.08984 2.65625 3.05078 4.40625C2.03906 6.18359 2.03906 8.34375 3.05078 10.0938C4.08984 11.8711 5.94922 12.9375 8 12.9375C10.0234 12.9375 11.8828 11.8711 12.9219 10.0938C13.9336 8.34375 13.9336 6.18359 12.9219 4.40625C11.8828 2.65625 10.0234 1.5625 8 1.5625ZM8 14.25C5.48438 14.25 3.1875 12.9375 1.92969 10.75C0.671875 8.58984 0.671875 5.9375 1.92969 3.75C3.1875 1.58984 5.48438 0.25 8 0.25C10.4883 0.25 12.7852 1.58984 14.043 3.75C15.3008 5.9375 15.3008 8.58984 14.043 10.75C12.7852 12.9375 10.4883 14.25 8 14.25ZM10.6523 5.5L10.1875 5.96484L8.90234 7.25L10.1875 8.53516L10.6523 9L9.75 9.92969L9.28516 9.46484L8 8.17969L6.71484 9.46484L6.25 9.92969L5.32031 9L5.78516 8.53516L7.07031 7.25L5.78516 5.96484L5.32031 5.5L6.25 4.59766L6.71484 5.0625L8 6.34766L9.28516 5.0625L9.75 4.59766L10.6523 5.5Z",
    fill: "#DA5252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.9e7af7249b9c0451f4a5814c11c6e8ad.svg";
export { ForwardRef as ReactComponent };